/**
 * Cart Component
 * Manejo del carrito de compras
 */

import { addToCart, updateCartItem as updateItem, removeCartItem as removeItem } from '../utils/shopify';

// Add to cart
document.addEventListener('submit', async (e) => {
  if (e.target.matches('form[action="/cart/add"]')) {
    e.preventDefault();

    const formData = new FormData(e.target);

    try {
      const data = await addToCart(formData);

      // Update cart and trigger animations
      if (window.Alpine) {
        const cartStore = window.Alpine.store('cart');
        await cartStore.fetchCart();
        cartStore.itemAdded();
        cartStore.open();
      }

      // Trigger custom event
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error al agregar al carrito');
    }
  }
});

// Update cart item quantity
export async function updateCartItem(line, quantity) {
  try {
    const cart = await updateItem(line, quantity);

    if (window.Alpine) {
      window.Alpine.store('cart').updateCount();
    }

    return cart;
  } catch (error) {
    console.error('Error updating cart:', error);
    throw error;
  }
}

// Remove from cart
export async function removeCartItem(line) {
  return removeItem(line);
}
